import {
  DEFAULT_SIDEBAR_WIDTH,
  PRODUCT_NAV_WIDTH,
} from "@zapier/canvas-constants";

/**
 * Calculates the sidebar width based on whether the sidebar is open or closed.
 *
 * @param isSidebarOpen - Whether the sidebar is open
 * @returns The calculated sidebar width in pixels
 */
export const calculateSidebarWidth = (isSidebarOpen: boolean): number =>
  isSidebarOpen ? PRODUCT_NAV_WIDTH + DEFAULT_SIDEBAR_WIDTH : PRODUCT_NAV_WIDTH;
